<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <v-card-title class="text-h5 mb-2 text-start font-weight-bold text-primary">{{
          `Terms & Conditions`
        }}</v-card-title>
        <v-card-text class="text-start">
          <div class="mb-4 font-weight-semibold text-subtitle1 text-secondary">
            By using <strong>Quizzr</strong>, you agree to the following terms and conditions.
            Please read them carefully.
          </div>
          <h3>1.⁠ ⁠Use of the Platform</h3>
          <div class="px-8">
            <ul>
              <li>
                You must be at least 13 years old to use Quizrr.
              </li>
              <li>
                You agree not to
                misuse the platform or attempt to breach security or manipulate
                scores.
              </li>
            </ul>
          </div>
          <h3>2.⁠ ⁠User Accounts</h3>
          <div class="px-8">
            <ul>
              <li>
                You are responsible for maintaining the confidentiality of your
                account and password.
              </li>
              <li>
                You must provide accurate and up-to-date
                information.
              </li>
            </ul> 
          </div>
          <h3>{{ `3.⁠ ⁠Content & Intellectual Property` }}</h3>
          <div class="px-8">
            <ul>
              <li>
                All content, including test materials, questions, analytics, logos, and branding, is the intellectual property of Quizrr or its licensors
              </li>
              <li>
                You may not reproduce, sell, or redistribute platform content without permission.
              </li>
            </ul>
          </div>
          <h3>{{ `4.⁠ ⁠Payments & Refunds` }}</h3>
          <div class="px-8">
            <ul>
              <li>
                Payment for test series is non-refundable unless otherwise stated.
              </li>
              <li>
                Access is granted based on the subscription model selected.
              </li>
            </ul>
          </div>
          <h3>5.⁠ ⁠Limitation of Liability</h3>
          <div class="px-8">
            Quizrr is not liable for any direct, indirect, or incidental damages resulting from:
            <ul>
              <li>
                Loss of access
              </li>
              <li>
                Performance issues
              </li>
              <li>
                Accuracy or results of test content
              </li>
            </ul>
          </div>
          <h3>6.⁠ ⁠Modifications</h3>
          <div class="px-8">
            We may update these terms at any time. Continued use of the site after changes constitutes acceptance.
          </div>
          <h3>7.⁠ ⁠Termination</h3>
          <div class="px-8">
            We may suspend or terminate accounts that violate our terms or attempt to disrupt the platform.
          </div>
          <h3>8.⁠ ⁠Governing Law</h3>
          <div class="px-8">
            These Terms are governed by the laws of India.
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script></script>
